<template>
  <div style="padding: 5px;">
    <TableListUser />
  </div>
</template>
<script>
import TableListUser from "./components/tableListUser";
export default {
  components: {
    TableListUser,
  },
  data() {
    return {};
  },
  methods: {},
  created() {},
};
</script>
<style></style>
